/***
 * 1. Inside the component, write:
 * `import { S3Media, ghostFlipidea } from '[PATH TO "third-party-services.js"]'`
 *
 * 2. Then use the variales
 */
import { loadStripe } from "@stripe/stripe-js";

export const S3Media = "https://dmrsshhv60eyf.cloudfront.net/";

export const UserFiles = "https://d16ekqw4ikh7xf.cloudfront.net";

export const createCheckoutSession = async (session) => {
  const Stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  await Stripe.redirectToCheckout({
    sessionId: session,
  });
};
